import { render, staticRenderFns } from "./CadastrarSenha.vue?vue&type=template&id=0e631de7&scoped=true&lang=pug&"
import script from "./CadastrarSenha.vue?vue&type=script&lang=js&"
export * from "./CadastrarSenha.vue?vue&type=script&lang=js&"
import style0 from "./CadastrarSenha.vue?vue&type=style&index=0&id=0e631de7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e631de7",
  null
  
)

export default component.exports